module.exports = __webpack_public_path__ + "img/10bombas.d4d06de1.jpg";